import { toast } from "react-toastify";

let lastReadOnlyToastAt = 0;

/**
 * Throttled toast for read-only mutation blocks (API + UI).
 */
export const notifyReadOnlyBlocked = (
  message = "Access Denied: Read-only users cannot modify data"
) => {
  const now = Date.now();
  if (now - lastReadOnlyToastAt < 2000) return;
  lastReadOnlyToastAt = now;
  toast.error(message, { autoClose: 3000 });
};
